import React, { Component } from 'react';
import { observable, action, makeObservable } from 'mobx';
import {  observer } from 'mobx-react'
import Modal from '@/misc/Modal';
import { Minuta, Processo } from '@/modelo';
import MinutaService from '@/services/MinutaService';
import { IconButton, Tooltip } from '@mui/material';
import { Recycling } from '@mui/icons-material';

interface IPropsRestaurarMinutaArquivada {
    processo: Processo;
    minuta: Minuta;
    fechar: () => void;
}


class RestaurarMinutaArquivada extends React.Component<IPropsRestaurarMinutaArquivada> {
    modalAberto = false;

    fecharModal = () => {
        this.modalAberto = false;
        this.props.fechar();
    };

    abrirModal = () => {
        this.modalAberto = true;
    };

    restaurarMinutaArquivada = async () => {
       await MinutaService.restaurarMinutaArquivada(this.props.minuta);
       this.fecharModal();
   }

    constructor(props: IPropsRestaurarMinutaArquivada) {
        super(props);

        makeObservable(this, {
            modalAberto: observable,
            fecharModal: action,
            abrirModal: action
        });
    }

    render() {
        return (
            <>
                <Tooltip placement='bottom' title={"Restaurar versão"} >
                    <IconButton id="botaoRestaurarMinuta"
                        onClick={this.abrirModal}
                        style={{ width: '40px', height: '30px', padding: '0px' }}
                    >
                        <Recycling />
                    </IconButton >
                </Tooltip>
                <Modal aberto={this.modalAberto}
                    fecharModal={this.fecharModal}
                    funcaoAcaoPrimaria={this.restaurarMinutaArquivada}
                    labelAcaoPrimaria='Restaurar Minuta'
                    funcaoAcaoSecundaria={this.fecharModal}
                    labelAcaoSecundaria='Cancelar'
                    titulo={'Restaurar Minuta Arquivada'}
                    maxWidth='lg' fullWidth
                >
                    Deseja recuperar a minuta arquivada?
                </Modal>
            </>
        );
    }
}

export default observer(RestaurarMinutaArquivada);
